import * as React from "react";
import copy from "copy-to-clipboard";

import { CodeBtn, CouponContainer, InnerBox } from "./style";

import Toast from "../../../components/Toast";
import { LTReceiveToast } from "../../../components/LTReceiveToast";
import { CouponType } from "../../../services/banner";
import { TModuleWithImgProps } from "../../../services/playground";

import { getLitbLangFn } from "utils/language/index";
import { GetReceiveCouponResp } from "utils/zeusFetch";

export interface CouponProps extends TModuleWithImgProps {
	columnSize: number;
	coupons: RenderCoupon[];
	positionId: string;
	type: CouponType;
	spmClick: (index: number) => void;
	getCoupons: (code: string) => Promise<GetReceiveCouponResp>;
}
export interface RenderCoupon {
	img: string;
	code: string;
	width: number;
	height: number;
}
interface CouponState {
	showToast: boolean;
	status: number;
	type: CouponType;
}
class CouponCode extends React.Component<CouponProps, CouponState> {
	constructor(props: CouponProps) {
		super(props);
		this.state = {
			showToast: false,
			status: -1,
			type: this.props?.type || CouponType.CopyCoupon,
		};
	}
	// 复制型优惠券
	onClickCopyBtn = (code: string) => {
		copy(code);
		this.setState(
			() => {
				return {
					showToast: true,
				};
			},
			() => {
				setTimeout(() => {
					this.setState(() => {
						return {
							showToast: false,
						};
					});
				}, 3000);
			},
		);
	};
	// 领取型优惠券
	onClickReceiveCoupon = (code: string) => {
		this.props.getCoupons(code).then((res: GetReceiveCouponResp) => {
			this.setState(() => {
				return {
					showToast: res.code === "1000000",
					status: res.info?.status,
				};
			});
		});
	};
	renderCoupon = (coupons: RenderCoupon[]) => {
		return coupons.map((item: RenderCoupon, index) => {
			return (
				<CodeBtn
					key={`${item.code}_${index}`}
					imgUrl={item.img}
					onClick={() => {
						this.props.spmClick && this.props.spmClick(index);
						if (this.props.type === CouponType.CopyCoupon) {
							this.onClickCopyBtn(item.code);
						} else {
							this.onClickReceiveCoupon(item.code);
						}
					}}
				/>
			);
		});
	};

	renderToast = () => {
		if (this.state.type === CouponType.CopyCoupon) {
			return (
				<Toast
					message={`${getLitbLangFn("Coupon successfully copied", this.props?.language)}`}
					height={64}
					width={512}
				/>
			);
		}
		return (
			<LTReceiveToast
				isMobile={false}
				status={this.state.status}
				lang={this.props.language}
				onClose={() => {
					this.setState({ showToast: false });
				}}
			/>
		);
	};

	render() {
		const { columnSize, coupons, positionId } = this.props;
		const { showToast } = this.state;
		if (!!!coupons || coupons.length === 0) {
			return null;
		}
		return (
			<CouponContainer id={positionId}>
				<InnerBox
					columnSize={columnSize}
					rows={Math.ceil(+this.props.coupons.length / columnSize)}>
					{this.renderCoupon(this.props.coupons)}
				</InnerBox>
				{showToast && this.renderToast()}
			</CouponContainer>
		);
	}
}

export default CouponCode;
